import { render, staticRenderFns } from "./TwoColumnDataPanel.vue?vue&type=template&id=763c872c&scoped=true&lang=pug&"
import script from "./TwoColumnDataPanel.vue?vue&type=script&lang=js&"
export * from "./TwoColumnDataPanel.vue?vue&type=script&lang=js&"
import style0 from "./TwoColumnDataPanel.vue?vue&type=style&index=0&id=763c872c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763c872c",
  null
  
)

export default component.exports